import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data,
    purchasable: data?.purchasable,
    track_inventory: data?.track_inventory,
    category_ids:
      data?.categories?.map((c) => ({ label: c.name, value: c.id })) || [],
    for_whole_cart: data?.for_whole_cart || false,
  };
};

export const structure = (
  t,
  categories,
  fetchCategories,
  categoriesLoading,
  categoriesCount,
) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "image",
        label: `${t("wrappers_wrap_extras.wrap_photo")}*`,
        placeholder: t("wrappers_wrap_extras.upload_placeholder"),
        text: t("wrappers_wrap_extras.file_size_limit"),
        width: "47%",
      },

      {
        width: "47%",
      },
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("wrappers_wrap_extras.name_en")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_name_en"),
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: t("wrappers_wrap_extras.name_ar"),
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_name_ar"),
      },

      {
        name: `price`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_extras.price")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_price"),
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
      },

      {
        name: `price_after_discount`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_extras.price_after_discount")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_price"),
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
      },
      {
        name: `count_on_hand`,
        kind: "input",
        type: "number",
        label: t("wrappers_wrap_extras.quantity"),
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_quantity"),
      },
      {
        name: `width`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_extras.width")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_width"),
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>gm</p>,
      },
      {
        name: `height`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_extras.height")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_height"),
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>cm</p>,
      },
      {
        name: `length`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_extras.length")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_length"),
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>cm</p>,
      },

      {
        name: `weight`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_extras.weight")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_extras.write_weight"),
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>gm</p>,
      },
      {
        name: `category_ids`,
        kind: "multiSelect",
        label: t("products.label_recommended_categories"),
        width: "47%",
        placeholder: t("products.placeholder_choose_categories"),
        options: categories,
        onOpen: categories?.length <= 1 && fetchCategories,
        isLoading: categoriesLoading,
        getList: fetchCategories,
        count: categoriesCount,
      },
      {
        name: `for_whole_cart`,
        kind: "checkbox",
        label: t("wrappers_wraps.for_whole_cart") || "For Whole Cart",
        width: "fit-content",
      },
      {
        name: `purchasable`,
        kind: "checkbox",
        label: t("wrappers_wrap_extras.purchasable"),
        width: "fit-content",
      },
      {
        name: `track_inventory`,
        kind: "checkbox",
        label: t("wrappers_wrap_extras.track_inventory"),
        width: "fit-content",
      },
    ],
  },
];

export const validationSchema = (wrapId) =>
  Yup.object({
    en: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    // ar: Yup.object().shape({
    //   name: Yup.string().required('Required'),
    // }),
    price: Yup.number().required("required"),
    price_after_discount: Yup.number().required("required"),
    // count_on_hand: Yup.number().required("required"),
    image: Yup.string().required("Required"),
    height: Yup.number().required("required"),
    length: Yup.number().required("required"),
    weight: Yup.number().required("required"),
    width: Yup.number().required("required"),
    category_ids: Yup.array(),
    for_whole_cart: Yup.boolean(),
  });
